import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/css/lightgallery-bundle.css';

import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import {Carousel} from "./blocks/carousel";
import {ResourceCategoriesFilter} from './blocks/resources';

$(function () {

    basicNavigation();
    Carousel();
    ResourceCategoriesFilter();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    lightGallery(document.getElementById('lightgallery'), {
        controls: true,
        selector: '.lightgallery-item',
        plugins: [lgThumbnail]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

    $('.accordion--resources__link').each(function() {
        if($(this).data('not-member')) {
            $(this).on('click', function(event) {
                event.preventDefault();
                $('#login-modal').modal('toggle');
                return false;
            });
        }
    });
    $('.resource__link').each(function() {
        if($(this).data('not-member')) {
            $(this).on('click', function(event) {
                event.preventDefault();
                $('#filter-login-modal').modal('toggle');
                return false;
            });
        }
    });


    if($('.events').length > 0) {
        //modal
        var id = '';
        $('.event').on('click', function() {
            id = $(this).attr('id');
            inEventCheck(id);
            eventFull(id);
            setupEventModal(id);
        });

        if(window.location.hash) {
            id = window.location.hash.substring(1)
            inEventCheck(id);
            eventFull(id);
            setupEventModal(id);
            $('#eventModal').modal('show')
        }

        $('#eventModal').on('hidden.bs.modal', function() {
            $('.modal-body .event-modal-wrapper .event-modal-content').html('');
            $('.modal-title').html('');
            $('.modal-title .event-modal-wrapper .event-modal-image').html('');
        });

        //modal attend event button click
        $('#attend-event-button').on('click', function() {
            attendEvent(id);
        });

        $('#join-waitlist-button').on('click', function() {
            joinWaitlist(id);
        });
    }

});

function setupEventModal(eventID) {
    var content = $('.event-content-'+eventID).html();
    var title = $('.event-title-'+eventID).html();
    var image = $('.event-image-'+eventID).html();
    var date = $('.event-date-'+eventID).html();
    var organizer = $('.event-organizer-'+eventID).html();
    var location = $('.event-location-'+eventID).html();
    var swap = $('.event-swap-'+eventID).html();
    

    $('.modal-body .event-modal-wrapper .event-modal-content').html(content);
    $('.modal-body .event-modal-wrapper .event-modal-organizer').html(organizer);
    $('.modal-body .event-modal-wrapper .event-modal-location').html(location);
    $('.modal-body .event-modal-wrapper .event-modal-date').html(date);
    $('.modal-title').html(title);
    $('.modal-body .event-modal-wrapper .event-modal-image').attr('src', image);
    $('.modal-footer .alert').addClass('d-none');

    if($('.event-spaces-'+eventID).length > 0) {
        var remainingSpaces = $('.event-spaces-'+eventID).html();
        $('.modal-body .event-modal-wrapper .event-modal-spaces').html('Remaining Spaces: '+remainingSpaces);
    } else {
        $('.modal-body .event-modal-wrapper .event-modal-spaces').html('');
    }

    if($('.event-cost-'+eventID).length > 0) {
        var cost = $('.event-cost-'+eventID).html();
        $('.modal-body .event-modal-wrapper .event-modal-cost').html('$'+cost);
    } else {
        $('.modal-body .event-modal-wrapper .event-modal-cost').html('');
    }


    if(swap == 1) {
        $('.modal-footer #attend-event-button').addClass('d-none');
        $('.modal-footer #join-waitlist-button').removeClass('d-none');
    } else {
        $('.modal-footer #attend-event-button').removeClass('d-none');
        $('.modal-footer #join-waitlist-button').addClass('d-none');
    }
}

function attendEvent(eventID) {
    $.ajax({
        url: '/eventAttend/attend?event='+eventID,
        type: 'POST',
    }).done(function (data) {
        let json = JSON.parse(data);
        if(json.status === "success") {
            $('#attend-event-button').attr('disabled', true);
            $('#attend-event-button').text('');
            $('#attend-event-button').html('<i class="far fa-check-circle"></i>');
            $('.modal-footer .alert').addClass('alert-success');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
        if(json.status === "warning") {
            $('#attend-event-button').attr('disabled', true);
            $('#attend-event-button').text('Already In Event');
            $('.modal-footer .alert').addClass('alert-warning');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
        if(json.status === "error") {
            $('#attend-event-button').attr('disabled', true);
            $('.modal-footer .alert').addClass('alert-danger');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
    });
}

function joinWaitlist(eventID) {
    $.ajax({
        url: '/eventAttend/waitlist?event='+eventID,
        type: 'POST',
    }).done(function (data) {
        let json = JSON.parse(data);
        console.log(data);
        if(json.status === "success") {
            $('#join-waitlist-button').attr('disabled', true);
            $('#join-waitlist-button').text('');
            $('#join-waitlist-button').html('<i class="far fa-check-circle"></i>');
            $('.modal-footer .alert').addClass('alert-success');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
        if(json.status === "warning") {
            $('#join-waitlist-button').attr('disabled', true);
            $('.modal-footer .alert').addClass('alert-warning');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
        if(json.status === "error") {
            $('#join-waitlist-button').attr('disabled', true);
            $('.modal-footer .alert').addClass('alert-danger');
            $('.modal-footer .alert').removeClass('d-none');
            $('.modal-footer .alert').html(json.message);
        }
    });
}

function inEventCheck(eventID) {
    $.ajax({
        url: '/eventAttend/inEvent?event='+eventID,
        type: 'POST',
    }).done(function (data) {
        let json = JSON.parse(data);
        if(json.hideAttend === true) {
            $('#attend-event-button').attr('disabled', true);
            $('#attend-event-button').text('Already In Event');
            // $('#join-waitlist-button').addClass('d-none');
        }
        if(json.hideAttend === false) {
            $('#attend-event-button').attr('disabled', false);
            $('#attend-event-button').text('Attend Event');
            // $('#join-waitlist-button').removeClass('d-none')
        }
    });
}

function eventFull(eventID) {
    $.ajax({
        url: '/eventAttend/eventFull?event='+eventID,
        type: 'POST',
    }).done(function (data) {
        let json = JSON.parse(data);
        if(json.status === "success") {
            $('#attend-event-button').attr('disabled', true);
            $('#attend-event-button').text('Event Is Full');
            $('#join-waitlist-button').removeClass('d-none')
        } else {
            console.log(json.message)
            let swap = $('.event-swap-'+eventID).html();
            if(swap == 1) {
                $('#join-waitlist-button').removeClass('d-none')
            } else {
                $('#join-waitlist-button').addClass('d-none')
            }
            
        }
    });
}
